export default "__VITE_ASSET__wlDzlkgM__"